module.exports = __webpack_public_path__ + "img/brother-logo.3a394417.svg";